import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import Swal from 'sweetalert2';
import {BlogTagService} from '../../../../shared/services/blog-tag.service';

@Component({
    selector: 'app-blog-tags',
    templateUrl: './blog-tags.component.html',
    styleUrls: ['./blog-tags.component.scss']
})
export class BlogTagsComponent implements OnInit, OnDestroy {
    @ViewChild('formModal') formModal: TemplateRef<any>;

    tags: any[] = [];
    loading = false;
    form: FormGroup;
    editing: any | null = null;
    saving = false;

    private destroy$ = new Subject<void>();

    constructor(private fb: FormBuilder,
                private modal: NgbModal,
                private service: BlogTagService) {
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            name: ['', [Validators.required, Validators.maxLength(191)]]
        });
        this.fetch();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    fetch(): void {
        this.loading = true;
        this.service.list({page: -1}).pipe(takeUntil(this.destroy$)).subscribe(res => {
            this.loading = false;
            this.tags = (res && res.data) ? res.data : [];
        }, () => this.loading = false);
    }

    openCreate(): void {
        this.editing = null;
        this.form.reset({name: ''});
        this.modal.open(this.formModal, {centered: true});
    }

    openEdit(tag: any): void {
        this.editing = tag;
        this.form.patchValue({name: tag.name});
        this.modal.open(this.formModal, {centered: true});
    }

    submit(modalRef: any): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }
        this.saving = true;
        const obs = this.editing
            ? this.service.update(this.editing.id, this.form.value)
            : this.service.create(this.form.value);
        obs.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.saving = false;
            modalRef.close();
            this.fetch();
        }, () => this.saving = false);
    }

    remove(tag: any): void {
        Swal.fire({
            title: 'Delete this tag?',
            text: tag.name,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            customClass: {confirmButton: 'btn btn-danger', cancelButton: 'btn btn-outline-secondary ml-1'},
            buttonsStyling: false
        }).then(r => {
            if (r.isConfirmed) {
                this.service.remove(tag.id).pipe(takeUntil(this.destroy$)).subscribe(() => this.fetch());
            }
        });
    }
}
